<div
  class="item-container"
  [class.selected]="selected$ | async"
  [class.nesting-target]="isNestingTarget$ | async"
>
  <div
    class="item-color-indicator"
    [style.background-color]="color$ | async"
  ></div>
  <mat-icon
    *ngIf="subObjectCount$ | async; else objectIcon"
    [svgIcon]="'complex-object'"
    class="object-icon"
  ></mat-icon>
  <ng-template #objectIcon
    ><mat-icon [svgIcon]="'object'" class="object-icon"></mat-icon
  ></ng-template>
  <div class="item-info-container">
    <h3-annotation-label
      class="subtitle-03"
      [annotationType]="'object'"
      [annotationId]="objectItem.index"
    ></h3-annotation-label>
    <div class="body-03 item-subtitle">
      <ng-container *ngIf="shapeCount$ | async as shapeCount">
        <span class="shape-count">{{
          shapeCount | i18nPlural: { '=1': '1 shape', other: '# shapes' }
        }}</span>
        <span>-</span>
      </ng-container>
      <ng-container *ngIf="subObjectCount$ | async as subObjectCount">
        <span class="sub-object-count">{{
          subObjectCount
            | i18nPlural: { '=1': '1 sub-object', other: '# sub-objects' }
        }}</span>
        <span>-</span>
      </ng-container>
      <span>
        <span>#</span>
        <span class="object-id">{{ objectItem.index }}</span>
      </span>
    </div>
  </div>
  <h3-object-feedback-indicator
    [objectIndex]="objectItem.index"
  ></h3-object-feedback-indicator>
  <mat-icon
    id="missing-annotations-icon"
    *ngIf="missingAnnotationsTooltip$ | async as missingAnnotationsTooltip"
    [matTooltip]="missingAnnotationsTooltip"
    matTooltipClass="multi-line-tooltip"
    class="material-symbols-outlined"
    color="warn"
    >error</mat-icon
  >
  <button
    mat-icon-button
    class="scope-object-button"
    #scopeObjectButton
    (click)="scopeObject($event, 'mouse_single')"
  >
    <mat-icon class="material-symbols-outlined"> chevron_right </mat-icon>
  </button>
</div>
<h3-object-list-item-drop-areas
  [objectId]="objectItem.index"
></h3-object-list-item-drop-areas>
